/**
 * Menu chính, một nguồn duy nhất cho đầu trang (máy tính và điện thoại).
 *
 * Quy ước quan trọng (xem ghi-chu/quyet-dinh.md, mục "URL và menu"):
 * menu chỉ là cách TRÌNH BÀY. Muốn dời một mục sang trái, sang phải hay vào
 * dropdown khác thì sửa file này, KHÔNG đổi URL của trang. URL đặt theo loại
 * nội dung (/playbook/<bai>, /cong-cu/<cong-cu>, /thuat-ngu/<tu>...) và giữ
 * nguyên mãi, nên Google và các công cụ AI không mất dấu trang.
 *
 * Mục có `con` hiện dropdown khi rê chuột hoặc dùng bàn phím. Mọi liên kết con
 * luôn nằm sẵn trong HTML (chỉ ẩn bằng CSS), nên trang nào cũng có liên kết
 * nội bộ tới Từ điển, Chương trình... dù không hiện trên thanh chính.
 */
export const MENU_TRAI = [
  {
    nhan: "Giới thiệu",
    to: "/gioi-thieu",
    con: [
      { nhan: "Về fundraising.vn", to: "/gioi-thieu", mo: "Cách làm, cách ghi nguồn" },
      { nhan: "Bắt đầu từ đâu", to: "/bat-dau", mo: "Cho người gọi vốn lần đầu" },
      { nhan: "Hướng dẫn gọi vốn lần đầu", to: "/huong-dan/goi-von-lan-dau", mo: "Đọc trong 15 phút" },
      { nhan: "Dành cho nhà đầu tư nước ngoài", href: "https://investor.fundraising.vn", mo: "Investor Navigator, tiếng Anh" },
    ],
  },
  { nhan: "Lộ trình", to: "/lo-trinh" },
  {
    nhan: "Nguồn vốn",
    to: "/nguon-von",
    con: [
      { nhan: "Quỹ đầu tư", to: "/nguon-von", mo: "Danh mục, tiêu chí, cách nộp hồ sơ" },
      { nhan: "Chương trình hỗ trợ", to: "/chuong-trinh", mo: "Vườn ươm, tăng tốc, cuộc thi" },
      { nhan: "Quỹ nào phù hợp với bạn", to: "/cong-cu/quy-phu-hop", mo: "Khớp hồ sơ với quỹ" },
    ],
  },
];

export const MENU_PHAI = [
  {
    nhan: "Công cụ",
    to: "/cong-cu",
    con: [
      { nhan: "Tất cả công cụ", to: "/cong-cu", mo: "Miễn phí, không cần tài khoản" },
      { nhan: "Điểm sẵn sàng gọi vốn", to: "/cong-cu/diem-san-sang-goi-von" },
      { nhan: "Định giá vòng pre-seed", to: "/cong-cu/dinh-gia-pre-seed" },
      { nhan: "Bảng cổ phần và pha loãng", to: "/cong-cu/bang-co-phan-va-pha-loang" },
      { nhan: "Bản chuẩn bị của tôi", to: "/ban-chuan-bi", mo: "Gom mọi kết quả đã lưu" },
    ],
  },
  { nhan: "Mẫu", to: "/mau" },
  {
    nhan: "Playbook",
    to: "/playbook",
    con: [
      { nhan: "Tất cả bài viết", to: "/playbook" },
      { nhan: "Cẩm nang gọi vốn", to: "/playbook/cam-nang", mo: "Hướng dẫn từng bước" },
      { nhan: "Tình huống thực tế", to: "/playbook/cau-chuyen", mo: "Mổ xẻ một thương vụ" },
      { nhan: "Kinh nghiệm gọi vốn", to: "/playbook/kinh-nghiem", mo: "Sai lầm, câu quỹ hay hỏi" },
      { nhan: "Nhìn lại tuần, tháng", to: "/playbook/nhin-lai", mo: "Thương vụ và xu hướng" },
      { nhan: "Chính sách & ưu đãi", to: "/playbook/chinh-sach", mo: "Thuế, quỹ nhà nước" },
      { nhan: "Từ điển thuật ngữ", to: "/thuat-ngu", mo: "Giải nghĩa bằng ví dụ" },
      { nhan: "Video ngắn", to: "/video", mo: "Mỗi khái niệm trong 60 giây" },
    ],
  },
];
